import {OrientationChangeHandler, CleanupMethod, Dependencies} from 'services/screen';
import {orientationOf} from '../orientationOf';

export function onOrientationChange(
  callback: OrientationChangeHandler,
  di: Dependencies = {}
): CleanupMethod {
  const {wndw = window} = di;

  function handler(): void {
    const newOrientation = orientationOf(di);
    return callback(newOrientation);
  }

  wndw.addEventListener('orientationchange', handler);
  return () => wndw.removeEventListener('orientationchange', handler);
}
